import { BoxProps } from '@mui/system'
import { FC } from 'react'
import { ActivityTimeValue } from './ActivityTimeValue'
import { ActivityFieldBox } from './ActivityFieldBox'
import { EqualColumnsGrid } from '../EqualColumnsGrid'

type StartEndTimeBoxProps = BoxProps & {
  startMs: number
  startSeconds: number
  endMs: number
  endSeconds: number
  isCompleted: boolean
}

export const StartEndTimeBox: FC<StartEndTimeBoxProps> = ({ startMs, startSeconds, endMs, endSeconds, isCompleted, ...boxProps }) => (
  <EqualColumnsGrid {...boxProps} gap="0">
    <ActivityFieldBox combinedWith="right" label="Start">
      <ActivityTimeValue ms={startMs} seconds={startSeconds} data-testid="activity-card-start-time" />
    </ActivityFieldBox>
    <ActivityFieldBox combinedWith="left" label="End">
      <ActivityTimeValue ms={endMs} seconds={endSeconds} fallback={isCompleted ? undefined : '00:00'} data-testid="activity-card-end-time" />
    </ActivityFieldBox>
  </EqualColumnsGrid>
)
